<template>
  <div class="launchscreen">
    <div class="logo"></div>
    <div class="buttons-item">
      <LaunchscreenButtons
        @start-patient-session="startPatientSession()"
        @open-config-mode="openConfigMode()"
      ></LaunchscreenButtons>
    </div>
  </div>
</template>

<script>
import LaunchscreenButtons from '../components/LaunchscreenButtons'

export default {
  name: 'Launchscreen',
  components: {
    LaunchscreenButtons
  },
  methods: {
    startPatientSession() {
      this.$emit('start-patient-session')
    },
    openConfigMode() {
      this.$emit('open-config-mode')
    }
  }
}
</script>

<style scoped>
.launchscreen {
  display: grid;
  background-color: white;
  margin: 1%;
  grid-template-columns: 20.4% 57.2% 20.4%;
  grid-template-rows: 53.3% 22.4% 22.3%;
}

.logo {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../assets/logo.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.buttons-item {
  grid-row: 2;
  grid-column: 2;
}
</style>
